import React from 'react';

const LoadingSprintItem = () => (
  <div className="px-4 py-6 bg-white dark:bg-gray-900 rounded-xl mb-4 border border-gray-100 dark:border-gray-700 cursor-pointer transition-shadow">
    <div className="grid grid-cols-2 gap-4 items-center">
      <div className="h-4 w-3/4 bg-gray-300 dark:bg-gray-700 rounded"></div>

      <div className="justify-self-end">
        <div className="h-5 w-16 bg-gray-300 dark:bg-gray-700 rounded-full"></div>
      </div>
    </div>

    <ul className="flex space-x-4 list-none mt-4 text-sm items-center">
      <li className="flex items-center space-x-2">
        <div className="h-4 w-4 bg-gray-300 dark:bg-gray-700 rounded-full flex-shrink-0"></div>
        <div className="h-3 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
      </li>
      <li className="flex items-center space-x-2">
        <div className="h-4 w-4 bg-gray-300 dark:bg-gray-700 rounded-full flex-shrink-0"></div>
        <div className="h-3 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
      </li>
    </ul>
  </div>
);

export const LoadingSprints = ({ title = 'Loading Sprints...', count = 3 }) => {
  const loadingItems = Array(count).fill(null);

  return (
    <div className="bg-gray-50 dark:bg-gray-800 rounded-xl p-6 mb-5 animate-pulse">
      <div className="h-6 w-1/3 bg-gray-300 dark:bg-gray-700 rounded mb-4"></div>

      <div className="mt-2">
        {loadingItems.map((_, index) => (
          <LoadingSprintItem key={index} />
        ))}
      </div>
    </div>
  );
};

export default LoadingSprints;
